import { render, staticRenderFns } from "./VolontariList.vue?vue&type=template&id=8e6aad14&"
import script from "./VolontariList.vue?vue&type=script&lang=ts&"
export * from "./VolontariList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports